import React from 'react';
import Checkbox from '../Checkbox/Checkbox';

import classes from './CheckboxLabel.module.scss';

const CheckboxLabel = ({ className, id, onClick, label, type, name, checked, showCheckbox = true, error }) => {
  const containerClasses = [classes.content];
  className && containerClasses.push(className);

  return (
    <div className={containerClasses.join(' ')}>
      {showCheckbox && <Checkbox error={error} checked={checked} id={id} name={name} type={type} onClick={value => onClick(value)} />}
      <span className={classes.label}>{label}</span>
    </div>
  );
};

export default CheckboxLabel;
